// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 776 ? "wysiwyg-editor" : chunkId) + "." + {"453":"31bf9d75","587":"a51264fb","776":"d95ec97a"}[chunkId] + ".chunk.js";
};